<script>
import Employee from "@/components/modals/employee-hris.vue";
export default {
    name: "RpcppeModal",
    components: {
        Employee
    },
    computed: {
        isICFEmployee(){
            if(this.printOpts == 2){
                return true;
            }
            if(this.printOpts == 3){
                return true;
            }
            if(this.printOpts == 5){
                return true;
            }
            if(this.printOpts == 6){
                return true;
            }
            return false;
        },
        hasNoEmployeeSelected(){
            if(this.employeeId == "" || this.employeeId == null){
                return true;
            }
            return false;
        },
    },
    data() {
        return {
            employeeName: "",
            employeeId: "",
            submitted: false
        }
    },
    methods: {
        getEmployee() {
            this.$refs.employee.resetData();
            this.$bvModal.show("rpcppe-employee");
        },
        dropEmployee(data) {
            this.employeeId = data.idNo;
            this.employeeName = `${data.firstName} ${data.lastName}`;
            this.$bvModal.hide("rpcppe-employee");
        },
        printRpcppeEmployee(){
            if(this.hasNoEmployeeSelected){
                this.submitted = true;
                return;
            }
            this.$emit('printRpcppeEmployee', { id: this.employeeId, name: this.employeeName});
        }
    }
}
</script>
<template>
    <b-modal 
        id="rpcppe-modal" 
        title="Print RPCPPE" 
        size="md" 
        title-class="font-18" 
        hide-footer 
        no-close-on-backdrop
    >
        <p class="text-muted mb-0">Print RPCPPE By Employee</p>
        <div class="mb-3">
        <b-input-group>
            <template #append>
                <b-button 
                    @click="getEmployee" 
                    variant="outline-info"
                >
                    <i class="mdi mdi-clipboard-text-search-outline"></i>
                </b-button>
            </template>
            <input 
                autocomplete="off" 
                type="text" 
                disabled 
                placeholder="Search Employee..." 
                class="form-control"
                :class="{ 'is-invalid': submitted && hasNoEmployeeSelected }" 
                v-model="employeeName" 
            />
            </b-input-group>
            <div v-if="submitted && hasNoEmployeeSelected" class="invalid-feedback">
                <span>This value is required.</span>
            </div>
        </div>
        <button 
            type="button" @click="printRpcppeEmployee"
            class="btn btn-md btn-block btn-primary d-flex align-items-center justify-content-center mb-2">
            <i class="bx bx-download fs-6 me-2"></i>Print
        </button>
        <Employee ref="employee" @dropData="dropEmployee($event)" altId="rpcppe-employee"></Employee>
    </b-modal>
</template>